module.exports = __webpack_public_path__ + "static/CC1-053bb34966abab2b1dd6527fd509094c.mp3";